import type { IVtsExhibitor } from '../../Admin/Exhibitors/Exhibitors';

interface ProgressLineProps {
  exhibitor: IVtsExhibitor;
}

/**
 * Stage 2: "4 of 6 products you regularly stock are in your VTS basket". Stage 1 has no
 * personalisation yet, so the line renders nothing.
 */
export default function ProgressLine(_props: ProgressLineProps) {
  return null;
}
